// extracted by mini-css-extract-plugin
export default {"tooltip":"InputError_tooltip__xEIWa","inline":"InputError_inline__IrEMs"};